// Module
var code = `<div appHeaderBar>
    <header-bar-title>Edit Schedule</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="scheduleDetailEdit"
          id="scheduleDetailEdit"
          tid="scheduleDetailEdit"
          #scheduleDetailEditForm="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text" tid="scheduleNicknameHeader">
                    <span *ngIf="paymentSchedule?.frequency !== 'one-time'; else oneTime">Edit Payment Schedule</span>
                    <ng-template #oneTime>Edit One-Time Payment</ng-template>
                </div>
            </div>
            <div class="HOA-container__content">
                <!--Nickname-->
                <div [ngClass]="{ 'is-invalid': scheduleNicknameError }" class="Field">
                    <label class="Field-label">
                        {{ paymentSchedule?.frequency !== 'one-time' ?'Schedule Name' : 'Payment Name'}}
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>
                    <input type="text"
                           class="Input"
                           id="scheduleNickname"
                           name="scheduleNickname"
                           tid="scheduleNickname"
                           maxlength="50"
                           [(ngModel)]="currentNickname"
                           (change)="scheduleNicknameChange()"
                           (blur)="scheduleNicknameBlur()"
                           [attr.aria-invalid]="scheduleNicknameError"
                           [attr.aria-describedby]="scheduleNicknameError && 'scheduleNickname-error' || undefined">
                    <span class="Field-error" tid="scheduleNickname-error" id="scheduleNickname-error">
                                Please give your schedule a valid nickname.
                            </span>
                </div>

                <!--Payment Method-->
                <div [ngClass]="{ 'is-invalid': paymentMethodError }" class="Field">
                    <label class="Field-label" for="paymentMethod">
                        Payment Method
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>
                    <div class="Select">
                        <select tid="paymentMethod"
                                id="paymentMethod"
                                name="paymentMethod"
                                [attr.aria-invalid]="paymentMethodError"
                                [attr.aria-describedby]="paymentMethodError && 'paymentMethod-error' || undefined"
                                [(ngModel)]="currentPaymentMethod"
                                (change)="onChangePmtMethod()">
                            <option *ngFor="let paymentMethod of paymentMethods"  [ngValue]="paymentMethod">
                                {{((paymentMethod.nickname) ? paymentMethod.nickname : paymentMethod.line1) + ' (' + paymentMethod.maskedId + ')'}}
                            </option>
                        </select>
                        <span class="Select-arrow"></span>
                    </div>
                    <span tid="paymentMethod-error" id="paymentMethod-error" class="Field-error">
                                {{paymentMethodErrorMsg ? paymentMethodErrorMsg : "Please select a payment method."}}
                            </span>
                    <span tid="paymentMethodMessage" id="paymentMethodMessage" class="HOA-Field-detail">
                                {{ (currentPaymentMethod && currentPaymentMethod.routingNumber)? ACHMessage : "" }}
                            </span>
                </div>
                <div class="HOA-flextable-component__cell--50"></div>

                <!-- SCHEDULE AMOUNT SECTION STARTS - ONLY FOR FIXED AMOUNT SCHEDULES -->
                <div *ngIf="paymentSchedule && paymentSchedule.type == 'fixed-amount'" class="HOA-misc-guidedSteps__flex-padded">

                    <!--fixed day-->
                    <div *ngIf="paymentSchedule?.frequency !== 'one-time'" class="HOA-flex-component HOA-make-payment-item-row--top-justified" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            Payment Day of Month
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                            <div class="Select">
                                <select
                                    tid="newFixedDay"
                                    id="newFixedDay"
                                    name="newFixedDay"
                                    [(ngModel)]="fixedDay"
                                    (change)="changeFixedDay()">
                                    <option *ngFor="let day of daysOfMonth" [ngValue]="day">
                                        {{day}}
                                    </option>
                                </select>
                                <span class="Select-arrow"></span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="paymentSchedule?.frequency === 'one-time'" class="HOA-flex-component HOA-make-payment-item-row--top-justified" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            Payment Date
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                            <button type="button"
                                class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                                (click)="paymentDateHelper()"
                                tid="paymentDateHelper">
                                <span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
                                    <svg focusable="false"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 72 72">
                                        <title>Payment Date</title>
                                        <path class="stroke_layer"
                                                d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                fill="none"
                                                stroke="#838383"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="3.8">
                                        </path>
                                        <path class="fill_layer" d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                fill="#838383"
                                                stroke-width="3.8">
                                        </path>
                                        <path class="stroke_layer"
                                                data-name="stroke_layer"
                                                d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                fill="none"
                                                stroke="#838383"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="3.8">
                                        </path>
                                    </svg>
                                </span>
                            </button>
                             <app-mat-date-picker
                                    [tidValue]="'schedulepaymentDate'"
                                    [idValue]="'schedulepaymentDate'"
                                    *ngIf="paymentDatePickerConfig"
                                    [required]="true"
                                    [config]="paymentDatePickerConfig"
                                    (onDateChange)="paymentDateChange(\$event)">
                            </app-mat-date-picker>
                        </div>
                    </div>
                    <br>
                    <div *ngIf="paymentSchedule?.frequency !== 'one-time'" class="HOA-flex-component HOA-make-payment-item-row--top-justified" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            Next Payment Date
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                            <div class="Field-addonBox u-pT3">
                                <span>{{sortedFuturePayments?.[0]?.date?.formattedFullDate}}</span>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="HOA-flex-component HOA-make-payment-item-row--top-justified">
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <!-- single row in dues -->
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="amountSingleDueLabel">
                                    Amount
                                    <span class="asterisk-required">&nbsp;&#42;</span>
                                </label>
                                <span class="HOA-Field-detail">(Enter amount to be paid in box)</span>
                            </div>
                        </div>
                        <div [ngClass]="{ 'is-invalid': isDueAmountInvalid(amountToPay) }"
                             class="Field u-cf HOA-make-payment-item-row-amount">
                            <div class="Field-addonBox ">
                                <input id="amount1"
                                       name="amount1"
                                       tid="amountSingleDue"
                                       type="text"
                                       class="Input"
                                       [(ngModel)]="amountToPay"
                                       (focus)="clearAmountFieldWhen0(amountToPay)"
                                       (change)="updateAmount()"
                                       [attr.aria-invalid]="isDueAmountInvalid(amountToPay)"
                                       [attr.aria-describedby]="isDueAmountInvalid(amountToPay) && 'amount1-error' || undefined"
                                       maxlength="9"
                                       placeholder="{{accountBalanceTbd && 'TBD' || ''}}"
                                       custom-currency />
                                <button tid="amountSingleClearButton"
                                        type="button"
                                        class="Field-addon"
                                        (click)="clearDue()"
                                        aria-label="Click to clear payment amount">
                                    x
                                </button>
                            </div>
                            <span id="amount1-error" tid="amountSingleError" class="Field-error">
                                        {{amountToPayErrorMsg ? amountToPayErrorMsg : "Please enter an amount."}}
                                    </span>
                        </div>
                    </div>

                    <!--Administrative fee-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="convenienceFeeLabel">
                                    Administrative Fee
                                </label>
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                            <span tid="convenienceFeeAmount">{{currentConvenienceFee | currency}}</span>
                        </div>
                    </div>

                    <!--Amount to be paid-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="amountToBePaidLabel">
                                    Amount to be paid
                                </label>
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span tid="amountToBePaid"
                                          class="HOA-make-payment-amount-owed">
                                        {{amountToPayErrorMsg ? 'n/a' : totalAmount | currency}}
                                    </span>
                        </div>
                    </div>

                </div>
                <!-- SCHEDULE AMOUNT SECTION ENDS - ONLY FOR FIXED AMOUNT SCHEDULES -->

                <div class="u-pT5">
                    <input type="checkbox"
                           id="tcCheckbox"
                           name="tcCheckbox"
                           tid="tcCheckbox"
                           class="Field u-cf"
                           style="margin-bottom: 26px; accent-color: #00505c"
                           [(ngModel)]="tcCheckbox"
                           [ngClass]="{'is-invalid': false}">
                    <label for="tcCheckbox" class="HOA-font-light">
                        I agree to pay the total amount including any fees as shown above.
                    </label>
                </div>

                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link "
                            (click)="cancel()">
                        Back
                    </button>
                    <button name="submitSave"
                            id="submitSave"
                            tid="submitSave"
                            type="submit"
                            class="Button Button--blue "
                            [disabled]="submitDisabled()"
                            (click)="save()">
                        Save
                    </button>
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>
                    &nbsp;Indicates required field
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>
                    &nbsp;Payment Dates that fall on weekends or holidays will be paid the business day prior.
                </div>
            </div>
            <div *ngIf="sortedFuturePayments && paymentSchedule.type == 'fixed-amount'" class="HOA-remove-button-container">
                <div class="u-floatLeft">
                    <button name="scheduleDetails"
                            id="scheduleDetails"
                            tid="scheduleDetails"
                            type="button"
                            [ngClass]="sortedFuturePayments?.length > 1 ?'Button Button--link' :'Button--disabled' "
                            [disabled]="disableCancelNextPayment()"
                            (click)="cancelPayment()">
                        Cancel Next Payment
                    </button>
                </div>
                <div class="u-floatRight">
                    <button name="deleteSchedule"
                        id="deleteSchedule"
                        tid="deleteSchedule"
                        type="button"
                        class="Button Button--link"
                        (click)="removeSchedule()">
                        Cancel Schedule
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div *ngIf="sortedFuturePayments && paymentSchedule.type == 'account-balance'" class="HOA-remove-button-container">
         <button name="cancelSchedule"
                id="cancelSchedule"
                tid="cancelSchedule"
                type="button"
                class="Button Button--link"
                (click)="removeSchedule()">
            Cancel Schedule
        </button>
     </div>
</app-page-content>`;
// Exports
module.exports = code;